import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { EChartsOption } from 'echarts';

@Component({
  selector: 'app-incident-status-graph',
  templateUrl: './incident-status-graph.component.html',
  styleUrl: './incident-status-graph.component.scss',
})
export class IncidentStatusGraphComponent {
  @Input() set chartHeight(val: any) {
    if (val) this.height = val + 'px';
  }
  @Input() set graphIncidentData(val: any) {
    if (val) {
      this.setupChart(val);
    }
  }
  @Output() statusClicked = new EventEmitter<string>();
  height = '';
  chartOption: EChartsOption;
  onChartInit(ec: any) {
    ec.on('click', (params: any) => {
      if (params.componentType === 'series') {
        const clickedStatus = params.name; // e.g., 'Open', 'Closed', etc.
        console.log(clickedStatus);
        this.statusClicked.emit(clickedStatus); // Emit to parent
      }
    });
  }
  setupChart(val: any) {
    const isAllZero =
      val.openCount == 0 &&
      val.closedCount == 0 &&
      val.inProgressCount == 0 &&
      val.onHoldCount == 0 &&
      val.approvedCount == 0 &&
      val.rejectedCount == 0 &&
      val.verifiedCount == 0 &&
      val.snoozedCount == 0 &&
      val.completeCount == 0;
    this.chartOption = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
        formatter: (params: any) => {
          const item = params[0];
          const status = item.axisValue;
          const count = item.data === 0.1 ? 0 : item.data;
          return `<strong>${status}</strong><br/>Count: ${count}`;
        },
        backgroundColor: '#fff',
        borderColor: '#ccc',
        borderWidth: 1,
        textStyle: {
          color: '#000',
        },
      },
      xAxis: {
        type: 'category',
        data: [
          'Open',
          'Closed',
          'In Progress',
          'Completed',
          'On Hold',
          'Approved',
          'Rejected',
          'Verified',
          'Snoozed',
        ],
        axisLabel: {
          interval: 0, // Ensures all labels are shown on the x-axis
          rotate: 45, // Optional: Rotate labels if they overlap
        },
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          show: true,
        },
      },
      series: [
        {
          name: 'Incident Status',
          type: 'bar',
          data: [
            isAllZero ? 0 : val.openCount > 0 ? val.openCount : 0.1,
            isAllZero ? 0 : val.closedCount > 0 ? val.closedCount : 0.1,
            isAllZero ? 0 : val.inProgressCount > 0 ? val.inProgressCount : 0.1,
            isAllZero ? 0 : val.completeCount > 0 ? val.completeCount : 0.1,
            isAllZero ? 0 : val.onHoldCount > 0 ? val.onHoldCount : 0.1,
            isAllZero ? 0 : val.approvedCount > 0 ? val.approvedCount : 0.1,
            isAllZero ? 0 : val.rejectedCount > 0 ? val.rejectedCount : 0.1,
            isAllZero ? 0 : val.verifiedCount > 0 ? val.verifiedCount : 0.1,
            isAllZero ? 0 : val.snoozedCount > 0 ? val.snoozedCount : 0.1,
          ],
          itemStyle: {
            color: (params) => {
              // Assign different colors to each bar
              const colorList = [
                '#ff5733', // Open
                '#33ff57', // Closed
                '#006400', // Completed
                '#3357ff', // In Progress
                '#ff33a6', // On Hold
                '#33fff0', // Approved
                '#ff3333', // Rejected
                '#33ffbd', // Verified
                '#c033ff', // Snoozed
              ];
              return colorList[params.dataIndex];
            },
          },
        },
      ],
    };
  }
}
